import { Riksvegrute } from '@/domain/omrader';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';

export function transformRiksvegrute(data: unknown) {
    if (!data) return null;
    return new Riksvegrute(data['riksvegrute'], data['enumid']);
}

export function transformRiksvegruter(riksvegruter: unknown): Riksvegrute[] {
    return (riksvegruter as []).map(rv => transformRiksvegrute(rv));
}
